export default "__VITE_ASSET__DQf3LP83__"